<script>
  import Loading from "../../../../components/pages/Loading.svelte";
  import DialogTitle from "../../../../components/dialog/DialogTitle.svelte";
  import DialogSplitter from "../../../../components/dialog/DialogSplitter.svelte";
  import DialogContent from "../../../../components/dialog/DialogContent.svelte";
  import DialogBottomControls from "../../../../components/dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../../../../components/dialog/DialogBottomControlButton.svelte";
  import { getContext, onMount } from "svelte";
  import DisplayOnlineLicenseSelectableSerials from "../DisplayOnlineLicenseSelectableSerials.svelte";
  import { useSerialWithOnlineLicense } from "../../../../utils/onlineLicense.js";
  import { FetchError } from "../../../../utils/getData.js";
  import { getNotificationsContext } from "svelte-notifications"
  import Alert from "../../../../components/Alerts/Alert.svelte";
  import { translate } from "../../../../i18n/i18next.js";
  import Button from "../../../../components/button/Button.svelte";
  import Stack from "../../../../components/layout/Stack.svelte";

  export let onClickClose
  export let accessTokenLicenseList
  export let asprovaId
  export let password

  const {addNotification} = getNotificationsContext()

  const {handleNonBlockingFetchErrors} = getContext("fetchErrorHandler")

  /**
   * @type {"loading"|"loaded"|"error"}
   */
  let status = "loading"

  let licenses = []
  async function retrieveLicenseList(accessToken) {
    status = "loading"
    const response = await fetch("/api/license/online/license-list", {
      method: "POST",
      body: JSON.stringify({accessToken}),
      headers: {
        "Content-Type": "application/json",
      }
    })
    if (response.ok) {
      const data = await response.json()
      // if only one license is selectable, skip the selection as it is not necessary
      if (data.licenses.length === 1) {
        // moveNext(licenseList[0])
      }
      status = "loaded"
      return data.licenses
    } else {
      addNotification({
        text: translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.messages.failedToRetrieveLicenseList"),
        position: "top-right",
        type: "error",
        removeAfter: 4000,
      })
      status = "error"
    }
  }

  /**
   *
   * @param {{
   *   serialNumber: string,
   * }} data
   */
  async function useLicense(data) {
    try {
      // try to use a license of the given serial number
      await useSerialWithOnlineLicense({
        asprovaId,
        password,
        serialNumber: data.serialNumber,
        subSerialNumber: 0,
      })

      addNotification({
        text: translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.messages.enabledOnlineLicense"),
        position: "top-right",
        removeAfter: 4000,
        type: "success",
      });

      // if it succeeds, close the dialog
      onClickClose()
    } catch (e) {
      if (e instanceof FetchError) {
        handleNonBlockingFetchErrors(e.error)
      }
      console.log(e)
    }
  }

  onMount(async () => {
    licenses = await retrieveLicenseList(accessTokenLicenseList)
  })
</script>

<DialogTitle title={translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.title")}/>
<DialogSplitter/>
<DialogContent>
  {#if status === "loaded"}
    {#if licenses.length > 0}
      <div>
        {translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.caption")}
      </div>
      <Stack direction="vertical" >
        <div style="display: flex; justify-content: end">
          <Button type="secondary" onClick={async () => licenses = await retrieveLicenseList(accessTokenLicenseList)}>
            {translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.reload")}
          </Button>
        </div>
        <DisplayOnlineLicenseSelectableSerials
          licenses={licenses}
          onSerialSelected={useLicense}
        />
      </Stack>
    {:else}
      <div>
        {translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.messages.noAssignedLicenses")}
      </div>
    {/if}
  {/if}
  {#if status === "loading"}
    <Loading height="200px"/>
  {/if}
  {#if status === "error"}
    <Alert type="error">
      {translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.messages.failedToRetrieveLicenseList")}
    </Alert>
  {/if}
</DialogContent>
<DialogSplitter/>
<DialogBottomControls>
  <DialogBottomControlButton type="secondary" onClick={onClickClose}>
    {translate("generic.cancel")}
  </DialogBottomControlButton>
</DialogBottomControls>
